import React, {useState, useMemo, useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
import convert from './convert'
import List from './List'

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

function Dropzone(props) {
  const [videos, setVideos] = useState([]);
  const onDropAccepted = useCallback(files => {
    setVideos([])
    const results = []
    Promise.all(files.map(async file => {
      const result = await convert(file)
      results.push(result)
    })).then(() => {
      setVideos(results)
    })
  }, [])
 
  const onDropRejected = useCallback(files => {
    console.log('rejected files', files)
  }, [])

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    accept: 'image/*',
    // maxSize: 5,
    onDropAccepted,
    onDropRejected,
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {}),
  }), [
    isDragActive,
    isDragReject,
    isDragAccept,
  ])

  return (
    <div className="container">
      <div {...getRootProps({style})}>
        <input {...getInputProps()} />
        <p>Drop image here, or click to select image.</p>
      </div>
      <List files={videos} />
    </div>
  )
}

export default Dropzone
